import image from '../../assets/images/placeholder.png';
import userImage from '../../assets/images/user-holder.png';

const SlashlessBaseUrl = process.env.REACT_APP_API_ROOT.replaceAll('/api/v1/', '').replaceAll('/api/v1', '');

const getSlashledUrl = (url:string) => {
  if(url.startsWith('/')){
    return url;
  }
  return `/${url}`;
}
export const getImageFromServer = (imgUrl: string) =>
  imgUrl ? SlashlessBaseUrl + getSlashledUrl(imgUrl) : image;

export const getUserImageFromServer = (imgUrl: string) =>
  imgUrl ? SlashlessBaseUrl + getSlashledUrl(imgUrl) : userImage;

  export const getLinkFromServer = (link: string) =>
  link ? SlashlessBaseUrl + `${link}` : "";
